import { Pipe, PipeTransform } from '@angular/core';
import { LearningResource } from '../models/learningResource';
import { Filter } from 'src/app/learning-resources/learning-resources.component';

@Pipe({
    name: 'learningResourcesFilter',
    pure: false,
    standalone: false
})
export class LearningResourcesFilterPipe implements PipeTransform {
    transform(items: LearningResource[], filter: Filter): any[] {

        let isAnyChecked = false;

        const filteredCostItems: LearningResource[] = [];
        const filteredFormatItems: LearningResource[] = [];
        const filteredDomainItems: LearningResource[] = [];

        filter.CostItems.forEach((value) => {
            if(value.checked){
                isAnyChecked = true;
                const item = items.filter(r => r.Cost?.toLowerCase() === value.name?.toLowerCase());
                filteredCostItems.push(...item);
            }
        });
        filter.FormatItems.forEach((value) => {
            if(value.checked){
                isAnyChecked = true;
                const item = items.filter(r => r.Formats?.toLowerCase().includes(value.name?.toLowerCase()))
                filteredFormatItems.push(...item);
            }
        });

        filter.DomainItems?.forEach((value) => {
            value.subtasks?.forEach((value) => {
                if(value.checked){
                    isAnyChecked = true;
                    const item = items.filter(r => r.Competency?.toLowerCase().includes(value.name?.toLowerCase()));
                    filteredDomainItems.push(...item);
                }
            });
        });

        if(!isAnyChecked){
            return items;
        }

        const arrays = [filteredCostItems, filteredFormatItems, filteredDomainItems].filter(r => r.length > 0);

        if(arrays.length === 0) return items;

        if(arrays.length === 1) return arrays[0];

        return arrays.reduce((accumulator, currentArray) => {
            const currentSet = new Set(currentArray.map(item => JSON.stringify(item)));
            return accumulator.filter(item => currentSet.has(JSON.stringify(item)));
        });
    }
}
